import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CustomLayoutProperties } from './layout.interface';

@Injectable({
    providedIn: 'root',
})
export class LayoutService {
    private customLayout = new BehaviorSubject({ enabled: false });
    get useCustomLayout() {
        return this.customLayout.asObservable();
    }

    constructor() {}

    setCustomLayout(props: CustomLayoutProperties) {
        this.customLayout.next(props);
    }
}
